function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H2C0.895431 16 0 15.1046 0 14V2Z",
  fill: "#8AD18D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0019 4.45837C12.194 4.45837 10.7311 5.92133 10.7311 7.72922C10.7311 8.52017 11.0106 9.2457 11.4804 9.81066H8.79237C9.26218 9.2457 9.54169 8.52017 9.54169 7.72922C9.54169 5.92133 8.07873 4.45837 6.27084 4.45837C4.46296 4.45837 3 5.92133 3 7.72922C3 9.5371 4.46296 11.0001 6.27084 11.0001H14.0019C15.8098 11.0001 17.2728 9.5371 17.2728 7.72922C17.2728 5.92133 15.8098 4.45837 14.0019 4.45837ZM6.27084 9.81066C5.12308 9.81066 4.1894 8.87699 4.1894 7.72922C4.1894 6.58145 5.12308 5.64777 6.27084 5.64777C7.41861 5.64777 8.35229 6.58145 8.35229 7.72922C8.35229 8.87699 7.41861 9.81066 6.27084 9.81066ZM14.0019 9.81066C12.8542 9.81066 11.9205 8.87699 11.9205 7.72922C11.9205 6.58145 12.8542 5.64777 14.0019 5.64777C15.1497 5.64777 16.0834 6.58145 16.0834 7.72922C16.0834 8.87699 15.1497 9.81066 14.0019 9.81066Z",
  fill: "white"
});

function SvgUnifiedMessaging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiedMessaging);
export default __webpack_public_path__ + "static/media/unified_messaging.e753bb0b.svg";
export { ForwardRef as ReactComponent };